export default {
    loading: false,
    done: false,
    produtos: [],
    totalPages: 0,
    filtersEdit: {
        page: 0,
        categoriaId: null,
        search: ""
    },
    appliedFilters: null
}